import {first, map, omitBy, isEmpty, isNil,find,forEach} from 'lodash';
import normalize from 'Utils/normalizer';

const response = (data: any) => {
  const getOrgDataByID = (orgID) => {
    let orgData = find(data.cart.org_data, obj => {
      return obj._id == orgID;
    })
    return orgData ? orgData : {};
  }

  const getProduct = (inventoryID) => {
    let prodObj: any = {};
    data.cart.inventory_data.find((obj) => {
      if (obj._id == inventoryID) {
        prodObj = obj
        prodObj.org_data = getOrgDataByID(obj.orgID)
      }
    })
    return normalize.response.inventory(prodObj)
  }

  const getStockVariants = (inventoryID, variant) => {
    let stockVariant: any = {};
    data.cart.inventory_data.find((obj) => {
      if (obj._id == inventoryID) {
        obj.ecomData.stockVariants.find((stockVariantObj) => {
          if (stockVariantObj.variantCode == variant) {
            stockVariant = stockVariantObj
          }
        })
      }
    })
    return stockVariant
  }
  const itemList:any = []
  forEach(data.cart.items, itemObj => {
    let productData = getProduct(itemObj.inventoryID);
    if(productData.disablePurchase){
      return;
    }
    let selectedVariant = getStockVariants(itemObj.inventoryID, itemObj.variantCode);
    if(selectedVariant && selectedVariant.stockLimit == 0){
      return;
    }
    let productUOMs:any = {};
    if (!isEmpty(productData.product?.baseUOM) || !isEmpty(productData.product?.stockUOMs)) {
      productUOMs[productData.product?.baseUOM.uom] = productData.product?.baseUOM.weight?.value || "0"
      forEach(productData.product?.stockUOMs, uomObj => {
        productUOMs[uomObj.uom] = uomObj.weight?.value || "0"
      })
    }
    let itemWeight = selectedVariant.weight?.value || '0'; // productUOMs[selectedVariant?.uom];

    let productType = productData.product.productType;

    itemList.push({
      cartID: itemObj.cartCode,
      productData: productData,
      productType: productType,
      selectedVariant: selectedVariant,
      variantImg:find(productData.productImages, (productImg) => {
        return productImg.variantCode === selectedVariant.variantCode;
      })?.image || productData.featuredImage?.image || '/assets/images/product-placeholder.png',
      quantity: itemObj.quantity > selectedVariant.stockLimit ? parseInt(selectedVariant.stockLimit) : parseInt(itemObj.quantity),
      weight: productType != 'VOUCHER'&& productType !== 'NO_SHIPPING' ? parseFloat(itemWeight) : 0
    })
  })

  return omitBy({
    cartID: data.cart._id,
    items: itemList
  }, isNil)
}

export default response;
